import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

export default class PortalErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("The artist portal encountered an unrecoverable error.", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="portal-error" role="alert">
          <section className="portal-error-card">
            <p className="portal-error-label">Johnsonboibeats Artist Portal</p>
            <h1>Something went wrong</h1>
            <p>The portal could not finish loading. Reload it to try again.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Reload portal
            </button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
